import { render, staticRenderFns } from "./FormBasic.vue?vue&type=template&id=7c44f706&scoped=true&"
import script from "./FormBasic.vue?vue&type=script&lang=ts&"
export * from "./FormBasic.vue?vue&type=script&lang=ts&"
import style0 from "./FormBasic.vue?vue&type=style&index=0&id=7c44f706&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c44f706",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('7c44f706', component.options)
    } else {
      api.reload('7c44f706', component.options)
    }
    module.hot.accept("./FormBasic.vue?vue&type=template&id=7c44f706&scoped=true&", function () {
      api.rerender('7c44f706', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/ConfiguracionCamaras/Howen/RecSetup/FormBasic.vue"
export default component.exports